<template>
    <div id="CedianGroup">
       <div class="data_head">
            <span class="cedian_text">基准点</span>
            <el-select v-model="baseMeasureNo" value-key="id" @change="selectmainMeasureNo">
                <el-option v-for="item in projectInfo" :key="item.id" :label="item.measureNo" :value="item"></el-option>
            </el-select>
            <!-- 下拉框多选 multiple-->
            <span class="cedian_text">子测点</span>
            <el-select multiple  collapse-tags v-model="childMeasuerNo" value-key="id" @change="selectchildMeasureNos">
                <el-option v-for="item in childCedianInfo" :key="item.id" :label="item.measureNo" :value="item.measureNo"></el-option>
            </el-select>
            <el-button type="warning" @click="save()">保&nbsp;存</el-button>
        </div>
        <div class="table tableContent">
            <el-table :data="list" style="width: 100%;" stripe :header-cell-style="{background:'#335ABB',color:'#FFF'}">
                <el-table-column align="center" prop="mainMeasureNo" label="基准点" ></el-table-column>
                <el-table-column align="center" prop="childMeasureNos" label="子测点"></el-table-column>
                <el-table-column align="center" label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删 除</el-button>
                    </template>
                </el-table-column>
            </el-table>
          <div class="pagination">
            <el-pagination
              @current-change="handleCurrentChange" :current-page="page"
              :hide-on-single-page="true"
              :page-size="pageSize" layout="total,prev, pager, next, jumper"
              :total="total" class="pagination" background >
            </el-pagination>
          </div>
        </div>

        <!-- 删除提示框 -->
        <el-dialog title="提示" :visible.sync="delDialogVisible" width="18%" :modal-append-to-body="false">
            <span>删除不可恢复，是否确定删除？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="delDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="del">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

    export default {
        name: 'CedianGroup',
        components: {

        },
        data() {
            return {
                data:[],
                list:[], // 用于存放数据
                projectInfo:[], // 基准点下拉框数据
                total: null,
                page: 1, // 初始页
                pageSize:10, // 每页显示的数据条数
                baseMeasureNo:'', // 基准点
                childMeasuerNo:[], // 子测点
                delDialogVisible: false,
                mainMeasureNo:'',
                childMeasureNos:[],
                childCedianInfo:[], // 子测下拉框定数据
            };
        },
        mounted: function () {
            this.getData(); // 表格数据接口
            this.getAllMeasures(); // 基准点与子测点数据接口
        },
        methods:{
            getData(){
                this.$axios.post('api/monitor/project/measureGroup/getAllMeasureGroups',{}).then(res => {
                    if(res.data.status == 200){
                        this.total = res.data.datas.values.length;
                        this.data = res.data.datas.values;
                        this.list = this.data.filter((item, index) =>
                            index < this.page * this.pageSize && index >= this.pageSize * (this.page - 1)
                        );
                    }
                    return
                });
            },
            getAllMeasures(){
                this.$axios.get('/api/monitor/project/measureGroup/getAllMeasures', {}).then(res => {
                    if(res.data.status == 200){
                        this.projectInfo = res.data.datas.values;
                    }
                    return
                })
            },
            selectmainMeasureNo(event) {
                this.mainMeasureNo = event.measureNo;
                this.$axios.get(`/api/monitor/project/measureGroup/getAllMeasures?measureNo=${event.measureNo}`).then(res => {
                    if(res.data.status == 200){
                        this.childCedianInfo = res.data.datas.values;
                    }
                    return
                })
            },
            selectchildMeasureNos(e){
                console.log(e,111111)
                this.childMeasureNos = e;
            },
            handleCurrentChange(val) {

            },
            handleDelete(row) {
                this.mainMeasureNo = row.mainMeasureNo;
                this.id = row.childProjectId;
                this.delDialogVisible = true;
            },
            del() {
                const req = {
                    mainMeasureNo: this.mainMeasureNo,
                    id: this.id
                }
                this.$axios.post('/api/monitor/project/measureGroup/deleteMeasureGroup', req).then(res => {
                    if(res.data.status == 200){
                        this.$message({
                            message: res.data.datas.values,
                            type:'success'
                        });
                        this.delDialogVisible = false;
                        this.getData();
                    }
                    return
                })
            },
            save(){
                const req = {
                    mainMeasureNo: this.mainMeasureNo,
                    childMeasureNos: this.childMeasureNos
                }
                console.log(req,222)
                this.$axios.post('/api/monitor/project/measureGroup/createMeasureGroup', req).then(res => {
                    if(res.data.status == 200){
                        this.$message({
                            message: res.data.datas.values,
                            type:'success'
                        });
                        this.baseMeasureNo = '';
                        this.childMeasuerNo = [];
                        this.getData();
                    }
                    if(res.data.status == 700){
                        this.$message({
                            message: "请勿重复添加基准点",
                            type:'error'
                        });
                        this.baseMeasureNo = '';
                        this.childMeasuerNo = [];
                        this.getData();
                    }
                    return
                })
            }
        }
    }
</script>

<style>

    #CedianGroup .el-select .el-input__inner{
        background-color: #3457DE;
        color: #FFF;  /* 选择后显示的颜色 */
    }

    #CedianGroup .el-table{
        color: #A7CCF6;
    }

    #CedianGroup .el-table__row {
        background-color: #0B3A68 !important;
    }

    #CedianGroup .el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: #021535;
    }

    #CedianGroup .el-table td{
        border: unset;
    }

    #CedianGroup .el-table th.is-leaf{
        border-bottom: none;
    }

    /* 加下列代码否则受#deviceStatic .el-table, .el-select-dropdown中background影响,会透明色 */
    #CedianGroup .el-table, .el-select-dropdown {
        background: #FFF;
    }

</style>

<style scoped>
    @import url('../../../assets/css/style.css');

    .pagination{
        margin-top: 30px;
        text-align: center;
    }

    .cedian_text{
        color: #FFF;
    }

</style>




// WEBPACK FOOTER //
// src/components/project/CedianGroup/CedianGroup.vue